import React from "react";

import "./notfound.css";

export default function NotFound({ setLoading }) {
  return (
    <div className="no-data-container">
      <h3 style={{ color: "red" }}>Record not found!</h3>
      <span style={{ width: "100%" }}>
        Please send your documents at IBCC for Attestation.
      </span>
      <table width="100%">
        <tbody>
          <tr>
            <td width="30%"></td>
            <td width="10%">
              <b>Address: </b>
            </td>
            <td width="50%">
              <p style={{ textAlign: "left", paddingLeft: "20px" }}>
                Plot No. 25, Street No. 38, I &amp; T Center, G-10/4, Islamabad,
                Pakistan.
              </p>
            </td>
            <td width="10%"></td>
          </tr>
          <tr>
            <td width="30%"></td>
            <td width="10%">
              <b>E-mail: </b>
            </td>
            <td width="50%">
              <p style={{ textAlign: "left", paddingLeft: "20px" }}>
                verification@ibcc.edu.pk
              </p>
            </td>
            <td width="10%"></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
